import React from "react";
import { DataTable } from "primereact/datatable";
import { scrollToTop, TableEmptyMessage } from "../Utils";
import TablePageReport, { adjustPageIndex } from "../TablePageReport";
import { filterTasksByTaskType } from "../../modules/Task/components/Utils";

export const RichDataTable = ({ paginatorLeftProps, ...props }) => {
  const [first, setFirst] = React.useState(null);
  React.useEffect(() => {
    return () => {
      scrollToTop();
    };
  }, []);
  
  React.useEffect(() => {
    adjustPageIndex(props.data, props.connectionTaskType, props.rows, first, setFirst, props.noConnectionTaskTypeFiltering);
  }, [props.data, props.connectionTaskType, props.rows, first, setFirst, props.noConnectionTaskTypeFiltering]);

  const handleSelectionChange = !(props.selection && props.setSelection) ? undefined : (event) => {
    if (props.noConnectionTaskTypeFiltering) {
      return props.setSelection(event.value);
    }
    const filteredSelection = (event.value || []).filter((item) =>
      filterTasksByTaskType(item, props.connectionTaskType),
    );
    props.setSelection(filteredSelection);
  };

  return (
    <DataTable
      value={props.data}
      first={first}
      onPage={(event) => {
        setFirst(event.first);
        scrollToTop();
      }}
      paginatorLeft={
        <TablePageReport
          className="pad-lft"
          totalRecords={props.data.length}
          filteredRecords={props.data.length}
          first={first}
          rows={props.rows}
          emptyText={paginatorLeftProps && paginatorLeftProps.emptyText || "Keine Einträge"}
          itemName={paginatorLeftProps && paginatorLeftProps.itemName || "Eintrag"}
          itemNamePlural={paginatorLeftProps && paginatorLeftProps.itemNamePlural || "Einträge"}
        />
      }
      emptyMessage={
        props.isLoading ? null : (
          <TableEmptyMessage itemNamePlural={paginatorLeftProps && paginatorLeftProps.itemNamePlural || "Einträge"} />
        )
      }
      selection={props.selection}
      onSelectionChange={handleSelectionChange}
      {...props}
    />
  );
};
